import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Button, Tooltip } from "antd";
import { useIntl } from "react-intl";
import AssetUploadModal from "../../../util/AssetUploadModal";
import { UploadOutlined } from "@ant-design/icons";
import { addAsset } from "../../../../features/asset/assetSlice";

const Dropzone = (props) => {
  const { id, branchId, resource, changeRefreshTimestamp } = props;
  const [toUploadFile, setToUploadFile] = useState(null);
  const [uploadModalVisible, setUploadModalVisible] = useState(false);

  const intl = useIntl();
  const onDrop = useCallback((acceptedFiles) => {
    const newFiles = acceptedFiles.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        fileName: file.name,
      })
    );
    setToUploadFile(newFiles[0]);
    setUploadModalVisible(true);
  }, []);

  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: true,
    onDrop,
    maxFiles: 1,
    maxSize: 10485760,
    accept:
      "image/jpeg, image/png, application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  });

  const closeModal = () => {
    setUploadModalVisible(false);
    changeRefreshTimestamp();
  };

  return (
    <div>
      <Tooltip
        placement="top"
        title={intl.formatMessage({
          id: "app.actions.upload_files",
        })}
        arrowPointAtCenter
      >
        <Button
          type="primary"
          icon={<UploadOutlined />}
          size={"small"}
          onClick={open}
        />
      </Tooltip>
      <input {...getInputProps()} />
      <AssetUploadModal
        visible={uploadModalVisible}
        closeModal={closeModal}
        mode={"new"}
        file={toUploadFile}
        addAsset={addAsset}
        branch_id={branchId}
        id={id}
        resource={resource}
      />
    </div>
  );
};

export default Dropzone;
